import { Typography, Tooltip, IconButton, } from '@one-thd/sui-atomic-components';
import { InfoFilled } from '@one-thd/sui-icons';
import React, { useMemo } from 'react';
import { useCommonContext } from '../../hooks/useContexts';
import { renderOrderTotal } from './util/format';
import { separateReturnedFG } from '../../utils/returns/returns-fg-helper';
import { FeatureSwitches } from '../../constants/feature-switches';
var savingsText = function (hasProXtraSaving, customerType, hasPreferredDiscFlag) {
    if (hasProXtraSaving && customerType === 'b2b') {
        return (React.createElement("div", { className: "sui-flex sui-flex-col" },
            React.createElement(Typography, { "data-testid": "pro-xtra-savings-text" },
                "ProXtra Savings:",
                hasPreferredDiscFlag !== 'N' && (React.createElement(Typography, { "data-testid": "pro-xtra-preferred-pricing" }, "(Preferred Pricing Applied)")))));
    }
    return (React.createElement("div", { className: "sui-flex sui-flex-col" },
        React.createElement(Typography, null, "Savings:")));
};
export var OrderTotal = function (_a) {
    var _b, _c, _d, _e, _f;
    var _g = _a.deliveryCharge, deliveryCharge = _g === void 0 ? 0 : _g, _h = _a.hasPreferredDiscFlag, hasPreferredDiscFlag = _h === void 0 ? 'N' : _h, _j = _a.hasProXtraSaving, hasProXtraSaving = _j === void 0 ? false : _j, _k = _a.orderDetailsData, _l = _k.grandTotalAmount, grandTotalAmount = _l === void 0 ? 0 : _l, _m = _k.subTotalAmount, subTotalAmount = _m === void 0 ? 0 : _m, _o = _k.taxTotalAmount, taxTotalAmount = _o === void 0 ? 0 : _o, _p = _k.otherDiscountAmount, otherDiscountAmount = _p === void 0 ? 0 : _p, _q = _k.returnTotal, returnTotal = _q === void 0 ? 0 : _q, statusDescription = _k.statusDescription, fulfillmentGroups = _k.fulfillmentGroups, _r = _a.shippingCharge, shippingCharge = _r === void 0 ? 0 : _r, customerType = _a.customerType, filteredFulfillmentObject = _a.filteredFulfillmentObject, militaryDiscount = _a.militaryDiscount, orderDetailsData = _a.orderDetailsData;
    var isMobile = useCommonContext().isMobile;
    var dataUnavailable = '---';
    var orderedGroups = useMemo(function () { return separateReturnedFG(filteredFulfillmentObject || []); }, [filteredFulfillmentObject]).orderedGroups;
    // checking if any item has returned description for the fullfillmentgroups
    var hasReturnedItemStatus = useMemo(function () {
        return orderedGroups === null || orderedGroups === void 0 ? void 0 : orderedGroups.some(function (group) {
            var _a;
            return (_a = group === null || group === void 0 ? void 0 : group.lineItems) === null || _a === void 0 ? void 0 : _a.some(function (item) { return (item === null || item === void 0 ? void 0 : item.statusDescription) === 'Returned'; });
        });
    }, [orderedGroups]);
    var isReturnComplete = statusDescription === 'Returned' || hasReturnedItemStatus;
    var validReturnTotal = Boolean(returnTotal) || grandTotalAmount < 0;
    // for BOPIS order no Shipping Label
    var currencyFormatter = function (price) {
        var money = 0;
        if (price === undefined || price === null)
            return dataUnavailable;
        if (price < 0) {
            money = price * -1;
        }
        else {
            money = price;
        }
        return money.toLocaleString('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        });
    };
    var modifiedOtherDiscountAmount = function () {
        return otherDiscountAmount;
    };
    var renderLumberFee = function () {
        var lumberFee = orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.lumberFee;
        if (!lumberFee)
            return null;
        var lumberFeeTitle = 'This transaction includes lumber, subject to an “eco fee” which is being paid on your behalf by The Home Depot.';
        return (React.createElement("div", { className: "sui-flex sui-justify-between" },
            React.createElement(Typography, null,
                React.createElement("span", { className: "sui-inline-flex sui-items-center sui-gap-1" },
                    "CA Lumber Fee:",
                    React.createElement(Tooltip, { placement: "bottom", title: lumberFeeTitle },
                        React.createElement(IconButton, { color: "info-strong", buttonSize: "tight", icon: InfoFilled, "aria-label": "Lumber Fee Information" })))),
            React.createElement(Typography, { decoration: "line-through" },
                "$",
                currencyFormatter(lumberFee))));
    };
    return (React.createElement("div", { className: "sui-col-span-1 sui-order-3 md:sui-col-span-1  md:sui-order-2 ".concat(!isMobile ? 'sui-ml-12' : '') },
        React.createElement("div", { className: "sui-flex sui-flex-col lg:sui-gap-2 sm:sui-gap-1" },
            React.createElement(React.Fragment, null,
                React.createElement("div", { className: "sui-flex sui-justify-between" },
                    React.createElement(Typography, { weight: "bold" }, "Subtotal:"),
                    React.createElement(Typography, { weight: "bold" },
                        "$",
                        currencyFormatter(subTotalAmount)),
                    ' '),
                (militaryDiscount === null || militaryDiscount === void 0 ? void 0 : militaryDiscount.chargeCategory) === 'DISCOUNT' &&
                    Number((_b = militaryDiscount === null || militaryDiscount === void 0 ? void 0 : militaryDiscount.chargeAmount) !== null && _b !== void 0 ? _b : '0') > 0 && (React.createElement("div", { className: "sui-text-success sui-flex sui-justify-between" },
                    React.createElement(Typography, null, "Military Discount:"),
                    React.createElement(Typography, null,
                        "-$", militaryDiscount === null || militaryDiscount === void 0 ? void 0 :
                        militaryDiscount.chargeAmount))),
                Boolean(modifiedOtherDiscountAmount()) && (React.createElement("div", { className: "sui-text-success sui-flex sui-justify-between" },
                    savingsText(hasProXtraSaving, customerType, hasPreferredDiscFlag),
                    React.createElement(Typography, { "data-testid": "pro-xtra-saving-value" },
                        "-$",
                        currencyFormatter(modifiedOtherDiscountAmount())))),
                (fulfillmentGroups === null || fulfillmentGroups === void 0 ? void 0 : fulfillmentGroups.find(function (item) {
                    return ['BuyOnlinePickupInStore', 'BuyOnlineShipToStore'].includes(item.fulfillmentType);
                })) ? (React.createElement("div", { className: "sui-flex sui-justify-between" },
                    React.createElement(Typography, { className: "sui-text-base" }, "Pickup:"),
                    React.createElement(Typography, { color: "success" }, "FREE"))) : null,
                (fulfillmentGroups === null || fulfillmentGroups === void 0 ? void 0 : fulfillmentGroups.find(function (item) {
                    return ![
                        'BuyOnlinePickupInStore',
                        'BuyOnlineShipToStore',
                        'InStorePurchase',
                        'InStore',
                    ].includes(item.fulfillmentType);
                })) ? (React.createElement("div", { className: "sui-flex sui-justify-between" },
                    React.createElement(Typography, { className: "sui-text-base" }, "Delivery:"),
                    shippingCharge + deliveryCharge > 0 ? (React.createElement(Typography, { "data-testid": "total-express-delivery" },
                        "$", (_c = (shippingCharge + deliveryCharge)) === null || _c === void 0 ? void 0 :
                        _c.toLocaleString('en-US', {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                        }))) : (React.createElement(Typography, { color: "success" }, "FREE")))) : null,
                ((_d = orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.mattressRecyclingFee) === null || _d === void 0 ? void 0 : _d.amount) &&
                    ((_e = orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.mattressRecyclingFee) === null || _e === void 0 ? void 0 : _e.amount) > 0 ? (React.createElement("div", { className: "sui-flex sui-justify-between" },
                    React.createElement(Typography, { className: "sui-text-base" },
                        "Mattress Recycling Fee:",
                        React.createElement(Tooltip, { placement: "top", title: "This transaction includes a mattress, subject to a Mattress Recycling Fee which is being paid on your behalf by The Home Depot." },
                            React.createElement(IconButton, { color: "info-strong", icon: InfoFilled, "aria-label": "Mattress Recycling Fee Information" }))),
                    React.createElement(Typography, { className: "sui-text-base", decoration: "line-through" },
                        "$",
                        currencyFormatter((_f = orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.mattressRecyclingFee) === null || _f === void 0 ? void 0 : _f.amount)))) : null,
                renderLumberFee(),
                React.createElement("div", { className: "sui-flex sui-justify-between" },
                    React.createElement(Typography, null, "Sales Tax:"),
                    React.createElement(Typography, null,
                        "$",
                        currencyFormatter(taxTotalAmount)),
                    ' '),
                !FeatureSwitches.enableRefundBreakdown &&
                    isReturnComplete &&
                    validReturnTotal ? (React.createElement("div", { className: "sui-flex sui-justify-between" },
                    React.createElement(Typography, null, "Refund Total:"),
                    React.createElement(Typography, { "data-testid": "refund-total" }, returnTotal !== undefined || returnTotal !== null
                        ? "$".concat(currencyFormatter(returnTotal || grandTotalAmount))
                        : dataUnavailable))) : null,
                React.createElement("hr", null),
                React.createElement("div", { className: "sui-flex sui-justify-between" },
                    React.createElement(Typography, { weight: "bold" }, "Total:"),
                    React.createElement(Typography, { weight: "bold" }, "$".concat(renderOrderTotal(orderDetailsData)))),
                FeatureSwitches.enableRefundBreakdown &&
                    isReturnComplete &&
                    validReturnTotal ? (React.createElement("div", { className: "sui-flex sui-justify-between" },
                    React.createElement(Typography, null, "Refund Total:"),
                    React.createElement(Typography, { "data-testid": "refund-total" }, returnTotal !== undefined || returnTotal !== null
                        ? "$".concat(currencyFormatter(returnTotal || grandTotalAmount))
                        : dataUnavailable))) : null))));
};
